<template>

    <div>
        <div class="menu-wrapper has-text-grey-dark">

            <div class="menu-group" style="background-color:#ff7191;">
                <div class="menu-group-title">
                    <p>&nbsp;</p>
                </div>
                <div class="menu-group-items">
                    <div class="menu-item">
                        <div class="big-pretty-button" @click="selected('do-nothing/do-nothing')" title="Do Nothing">
                            <div class="has-text-grey-dark p-2" style="position: absolute;">
                                <div class="is-block">
                                    <p class="is-size-5"><i class="fa-solid fa-circle-xmark"></i></p>
                                    <p class="is-size-7 has-text-weight-bold">DO NOTHING</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="menu-group" style="background-color:#00d1b2;">

                <div class="menu-group-title">
                    <p title="These split your code to do different things based on conditions you define">Email Actions</p>
                </div>

                <div class="menu-group-items">

                    <div class="menu-item">
                        <div class="big-pretty-button" @click="selected('email-actions/send-email')" title="Send an email to an email address.">
                            <div class="has-text-grey-dark p-2" style="position: absolute;">
                                <div class="is-block">
                                    <p class="is-size-5"><i class="fa-solid fa-paper-plane"></i></p>
                                    <p class="is-size-7 has-text-weight-bold">SEND</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="menu-item">
                        <div class="big-pretty-button" @click="selected('email-actions/signup-email')" title="Sign an email address up for a given email list.">
                            <div class="has-text-grey-dark p-2" style="position: absolute;">
                                <div class="is-block">
                                    <p class="is-size-5"><i class="fa-solid fa-envelope-circle-check"></i></p>
                                    <p class="is-size-7 has-text-weight-bold">ADD/REMOVE FROM LIST</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="menu-item">
                        <div class="big-pretty-button" @click="selected('email-actions/create-delete-email-list')" title="Create or delete an email list.">
                            <div class="has-text-grey-dark p-2" style="position: absolute;">
                                <div class="is-block">
                                    <p class="is-size-5"><i class="fa-solid fa-plus"></i>&nbsp;<i class="fa-solid fa-envelope"></i></p>
                                    <p class="is-size-7 has-text-weight-bold">CREATE / DELETE LIST</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>


            <div class="menu-group" style="background-color:#dea059;">

                <div class="menu-group-title">
                    <p title="These split your code to do different things based on conditions you define">Group Actions</p>
                </div>

                <div class="menu-group-items">

                    <div class="menu-item">
                        <div class="big-pretty-button" @click="selected('group-actions/add-remove-from-group')" title="Add or remove a user from a group.">
                            <div class="has-text-grey-dark p-2" style="position: absolute;">
                                <div class="is-block">
                                    <p class="is-size-5"><i class="fa-solid fa-user-plus"></i></p>
                                    <p class="is-size-7 has-text-weight-bold">ADD OR REMOVE USER</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="menu-item">
                        <div class="big-pretty-button" @click="selected('group-actions/create-group')" title="Create a new group.">
                            <div class="has-text-grey-dark p-2" style="position: absolute;">
                                <div class="is-block">
                                    <p class="is-size-5"><i class="fa-solid fa-users"></i></p>
                                    <p class="is-size-7 has-text-weight-bold">CREATE GROUP</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="menu-item">
                        <div class="big-pretty-button" @click="selected('group-actions/delete-group')" title="Delete an existing group.">
                            <div class="has-text-grey-dark p-2" style="position: absolute;">
                                <div class="is-block">
                                    <p class="is-size-5"><i class="fa-solid fa-users-slash"></i></p>
                                    <p class="is-size-7 has-text-weight-bold">DELETE GROUP</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="menu-item">
                        <div class="big-pretty-button" @click="selected('group-actions/modify-group-member-status')" title="Modify a user's status within a group.">
                            <div class="has-text-grey-dark p-2" style="position: absolute;">
                                <div class="is-block">
                                    <p class="is-size-5"><i class="fa-solid fa-user-gear"></i></p>
                                    <p class="is-size-7 has-text-weight-bold">CHANGE MEMBERSHIP STATUS</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>


            <div class="menu-group" style="background-color:#9dffaa;">

                <div class="menu-group-title">
                    <p title="These split your code to do different things based on conditions you define">Other Actions</p>
                </div>

                <div class="menu-group-items">

                    <div class="menu-item">
                        <div class="big-pretty-button" @click="selected('other-actions/send-notification')" title="Send a notification to a user.">
                            <div class="has-text-grey-dark p-2" style="position: absolute;">
                                <div class="is-block">
                                    <p class="is-size-5"><i class="fa-solid fa-bell"></i></p>
                                    <p class="is-size-7 has-text-weight-bold">SEND NOTIFICATION</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>


</template>

<script>
export default {
    name: 'MenuTabActions',
    props: {
        triggerType: {
            type: String,
            required: false,
            default: ''
        },
    },
    methods: {
        selected(type) {
            this.$emit('selected', type)
        }
    }
}
</script>

<style scoped lang="scss">
.menu-wrapper {
    overflow-x: auto;
    display: flex;
}
.menu-group {
    margin: 0 10px;
    padding: 10px;
    border-radius: 6px;

    .menu-group-title {
        width:100%;
        font-weight: bold;
        font-size: 1.5rem;
    }

    .menu-group-items {
        overflow-x: auto;
        display: flex;
    }

    &:first-child {
        margin-left: auto;
    }
    &:last-child {
        margin-right: auto;
    }
}
.menu-item {
    margin: 0 10px;

    & > div {
        padding: 0;
        height: 100px;
        width: 100px;
    }
}
.big-pretty-button {
    border: 0.5px solid #4a4a4a;
}
</style>
